import { useCallback, useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { api } from "../../../../utils/api";
import { useNavigate } from "react-router-dom";

import LoginIcon from "./icons.png";

import "./login.css";
import { trackPromise } from "react-promise-tracker";
import { FilledInput, FormControl, IconButton, Input, InputAdornment, InputLabel } from "@mui/material";

const Login = () => {
	const [loginCredentials, setLoginCredentials] = useState<any>({
		user_id: "",
		password: ""
	});
	const [showPassword, setShowPassword] = useState<boolean>(false);
	const navigate = useNavigate();
	// console.log("loginCredentials", loginCredentials);

	const handleClickShowPassword = () => setShowPassword((show: boolean) => !show);

	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};

	const handleChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name, value } = event.target;
			setLoginCredentials(Object.assign({}, loginCredentials, { [name]: value }));
		},
		[loginCredentials]
	);

	const handleSubmit = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				event.preventDefault();
				const loginPayload = {
					...loginCredentials
				};
				// console.log("loginPayload", loginPayload);
				const response = await trackPromise(api.auth.login(loginPayload));

				if (response) {
					const { result, token } = response;
					// console.log("result", result);
					localStorage.setItem("@jwt", token);
					localStorage.setItem("@user", JSON.stringify(result));
					const pathname = "/idr/dashboard";
					navigate(pathname);
				}
			} catch (error: any) {
				console.log("Invalid Login!");
			}
		},
		[loginCredentials, navigate]
	);

	return (
		<div className="login">
			<div className="login-cont-outer">
				<div className="login-cont-inner">
					<div
						style={{
							flex: 1,
							alignItems: "center",
							justifyContent: "center",
							display: "flex",
							marginBottom: "1.5rem"
						}}
					>
						<img src={LoginIcon} height={78} width={120} style={{ textAlign: "center" }} />
					</div>
					<div className="login-text">IDR Nexcaliber</div>
					<form className="form-container">
						<div className="form-field">
							{/* <input
								placeholder="User ID"
								name="user_id"
								type="text"
								value={loginCredentials.user_id}
								height={200}
								onChange={handleChange}
							/> */}
							<FormControl sx={{ width: "90%" }} variant="standard">
								<InputLabel htmlFor="standard-adornment-userId" color="secondary">
									User ID
								</InputLabel>
								<Input
									id="standard-adornment-userId"
									type="text"
									color="secondary"
									name="user_id"
									value={loginCredentials.user_id}
									onChange={handleChange}
								/>
							</FormControl>
						</div>
						<div className="form-field">
							{/* <input
								placeholder="Password"
								name="password"
								value={loginCredentials.password}
								type="password"
								onChange={handleChange}
							/> */}
							<FormControl sx={{ width: "90%" }} variant="standard">
								<InputLabel htmlFor="standard-adornment-password" color="secondary">
									Password
								</InputLabel>
								<Input
									id="standard-adornment-password"
									type={showPassword ? "text" : "password"}
									color="secondary"
									name="password"
									value={loginCredentials.password}
									onChange={handleChange}
									endAdornment={
										<InputAdornment position="end">
											<IconButton
												aria-label="toggle password visibility"
												onClick={handleClickShowPassword}
												onMouseDown={handleMouseDownPassword}
											>
												{showPassword ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									}
								/>
							</FormControl>
						</div>
						<button className="login_button" onClick={handleSubmit}>
							Login
						</button>
					</form>
				</div>
			</div>
		</div>
	);
};

export default Login;
